// src/App.js
import React, { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "./firebase";
import "./index.css";

import LoginPage from "./pages/LoginPage";
import AdminLayout from "./components/AdminLayout";

export default function App() {
const [user, setUser] = useState(null);
const [isAdmin, setIsAdmin] = useState(false);
const [loading, setLoading] = useState(true);

useEffect(() => {
return onAuthStateChanged(auth, async (u) => {
if (u) {
// Check if user is admin
const snap = await getDoc(doc(db, "admins", u.uid));
if (snap.exists()) {
setUser(u);
setIsAdmin(true);
} else {
setUser(null);
setIsAdmin(false);
await auth.signOut();
alert("Access denied. This panel is for admins only.");
}
} else {
setUser(null);
setIsAdmin(false);
}
setLoading(false);
});
}, []);

if (loading) return (
<div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", background: "var(--bg)" }}>
<div style={{ textAlign: "center" }}>
<div style={{ fontSize: 40, marginBottom: 16 }}>🚛</div>
<div style={{ color: "#F97316", fontFamily: "Syne", fontSize: 20, fontWeight: 800, letterSpacing: 4 }}>CREWBOARD</div>
<div style={{ color: "var(--text-muted)", marginTop: 8, fontSize: 13 }}>Loading admin panel…</div>
</div>
</div>
);

if (!user || !isAdmin) return <LoginPage />;
return <AdminLayout user={user} />;
}